module.exports = __webpack_public_path__ + "img/oracle-of-ages.89b293cb.jpg";